import {
    Card as MuiCard,
    Divider as MuiDivider,
    Grid,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Container,
    Drawer
} from '@mui/material'
import { spacing } from '@mui/system'
import styled from '@emotion/styled'


const Centered = styled.div`
  text-align: center;
`

const Card = styled(MuiCard)(spacing)

const Divider = styled(MuiDivider)(spacing)

function PendingOrdersPaymentDrawer({
    title,
    onChangeUserCount,
    entitlementData,
    visible,
    onClose,
    orderDetails,
    calculationData,
    noOfUsers,
    onSave,
    onPayment,
    onCancelOrder
}) {

    if (calculationData == undefined) {
        calculationData = {
            subtotal: 0,
            total: 0,
            net_amount: 0,
        }
    }

    const changeUserQty = (e) => {
        onChangeUserCount(e.target.value)
    }


    return (
        <div>
            <Drawer
                anchor="right"
                backdrop="static"
                variant="temporary"
                open={visible}
                onClose={onClose}
            >
                <Container>
                    <Centered spacing={1}>
                        <Typography variant='h6'
                            gutterBottom
                        >
                            {title}
                        </Typography>
                        <Divider spacing={10} />
                        <Typography> </Typography>
                    </Centered>
                    <Grid container spacing={3} style={{ paddingLeft: 1, paddingTop: 10, paddingRight: 1 }}>
                        <Grid item md={6}>
                            {orderDetails?.purchased_items[0].purchasetype?.short_name == 'New' ?
                                <TextField
                                    size='small'
                                    name="users"
                                    label="No of Users"
                                    value={noOfUsers}
                                    variant="outlined"
                                    fullWidth
                                    margin="dense"
                                    onChange={(e) => changeUserQty(e)}
                                    disabled
                                    my={2}
                                /> :
                                <Typography style={{ fontSize: 14 }} gutterBottom>
                                    No of Users : {noOfUsers}
                                </Typography>
                            }

                        </Grid>
                        <Grid item md={6}>
                            <Typography style={{ fontSize: 14 }} gutterBottom>
                                Purchase Type : {orderDetails?.purchased_items[0].purchasetype?.short_name}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} style={{ paddingLeft: 1, paddingTop: 10, paddingRight: 1 }}>
                        <Grid item md={6}>
                            <Typography variant='subtitle2'>
                                Renewal From :
                            </Typography>
                            <Typography
                                style={{
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                }}
                            >
                                {entitlementData?.expiry_date}
                            </Typography>
                        </Grid>
                        <Grid item md={6}>
                            <Typography variant='subtitle2'>
                                Till Date :
                            </Typography>
                            <Typography
                                style={{
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                }}
                            >
                                {orderDetails?.tillDate}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Card style={{ marginTop: 15 }}>
                        <Table size="small" style={{ marginTop: 15 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Plan Name</TableCell>
                                    <TableCell>Fixed Price</TableCell>
                                    <TableCell align="left"> Qty</TableCell>
                                    <TableCell align="left"> Unit Price</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {orderDetails?.purchased_items[0]?.plan?.name}
                                    </TableCell>
                                    <TableCell align="left">
                                        Rs {orderDetails?.purchased_items[0]?.fixed_charge}
                                    </TableCell>
                                    <TableCell align="left"> {noOfUsers || 0}</TableCell>
                                    <TableCell align="left">
                                        Rs {orderDetails?.purchased_items[0]?.unit_price}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                            <TableBody>
                                <TableRow>
                                    <TableCell rowSpan={8} />
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        Fixed Price
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {orderDetails?.purchased_items[0]?.fixed_charge}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        Subtotal
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {calculationData.subtotal}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        GST
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {' '}
                                        {orderDetails?.purchased_items[0]?.igst} %
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        Total
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {' '}
                                        {calculationData.total}{' '}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        Credit Amount
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {' '}
                                        {entitlementData?.credit_note}{' '}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        Net Amount
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {' '}
                                        {calculationData.net_amount}{' '}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Card>
                    <Grid container spacing={6}>
                        <Grid item md={12} />
                    </Grid>
                    <Grid container spacing={6} align="center" sx={{ paddingTop: 20, justifyContent: "space-between" }}>
                        <Grid item md={12}>
                            <Button onClick={onCancelOrder} variant="outlined" color="error" size="small" mt={3}>
                                Cancel Order
                            </Button>
                        </Grid>
                    </Grid>
                </Container>
            </Drawer>
        </div >
    );
}

export default PendingOrdersPaymentDrawer;